import { render, staticRenderFns } from "./CreditList.vue?vue&type=template&id=3c8f8079&scoped=true"
import script from "./CreditList.vue?vue&type=script&lang=js"
export * from "./CreditList.vue?vue&type=script&lang=js"
import style0 from "./CreditList.vue?vue&type=style&index=0&id=3c8f8079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f8079",
  null
  
)

export default component.exports